import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PageNames} from '../../../shared/page-names.enum';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {NavigationState} from '../../../model/navigation/navigation-state';
import {ModalConfig} from '../../../model/modal-config';
import {LabelkeyService} from '../../../services/labelkey/labelkey.service';
import {TvShopEntertainmentPack} from '../../../model/tv-shop-entertainment-pack';
import {BaseActions} from '../../../shared/base-actions';
import {Order} from '../../../model/order';
import {TvShopStateService} from '../../../services/state/tv-shop-state.service';
import {Router} from '@angular/router';
import {TvShopEntertainmentPackGroupIds} from '../../../constants/tv-shop-entertainment-pack/tv-shop-entertainment-pack-group.constants';

@Component({
  selector: 'app-ordering-modal-manager',
  templateUrl: './ordering-modal-manager.component.html',
  styleUrls: ['./ordering-modal-manager.component.less'],
  providers: [LabelkeyService]
})
export class OrderingModalManagerComponent extends BaseActions implements OnInit, OnChanges {

  modalConfig = new ModalConfig();

  @Input()
  order: Order;
  conditionsLabelKey: string;
  navigationState: NavigationState;
  error: Error;
  tvShopEntertainmentPack: TvShopEntertainmentPack;
  title = 'eos-tv-shop-ii.title.input-pincode-modal';
  description = 'eos-tv-shop-ii.text.input-pincode-modal-pincode';

  constructor(protected navigationService: NavigationService,
              protected labelkeyService: LabelkeyService,
              private router: Router,
              private stateService: TvShopStateService) {
    super();
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setLabels();
  }

  openModal(): void {
    this.modalConfig.showOrderPincode = true;
    this.setAdditionalModalConfig();
    this.navigationState = Object.assign({}, this.navigationService.state);
    this.registerComponent(PageNames.PINCODE_MODAL);
  }


  openConditions(): void {
    this.modalConfig.showOrderPincode = false;
    this.modalConfig.showOrderConditions = true;
    this.setAdditionalModalConfig();
    this.conditionsLabelKey = this.labelkeyService.getConditionsModalLabelKey(this.order.packOmapiId);
    this.registerComponent(PageNames.CONDITIONS_MODAL);
  }

  openOrderSucceeded(): void {
    this.modalConfig.showOrderPincode = false;
    this.modalConfig.showOrderSucceeded = true;
    this.setAdditionalModalConfig();
    this.registerComponent(PageNames.ORDERING_SUCCEEDED);
  }

  openOrderFailed(orderFailed: any): void {
    this.error = orderFailed.error;
    this.modalConfig.showOrderPincode = false;
    this.modalConfig.showOrderFailed = true;
    this.setAdditionalModalConfig();
    this.registerComponent(PageNames.ORDERING_FAILED);
  }

  openOrderMessage(): void {
    this.modalConfig.showOrderPincode = false;
    this.modalConfig.showOrderMessage = true;
    this.setAdditionalModalConfig();
    this.registerComponent(PageNames.ORDERING_MESSAGE);
  }

  closeModal(): void {
    if (this.shouldComeBackToProductDetailScreen()) {
      this.backToDetailPage();
    }
    this.modalConfig = new ModalConfig();
    this.registerComponent(PageNames.DETAIL_PAGE_INTRO);
    if (!this.modalConfig.showOrderConditions && !this.modalConfig.showOrderPincode) {
      this.navigationService.state = this.navigationState;
    }
    this.setAdditionalModalConfig();
    this.ngOnDestroy();
  }

  closeConditions(): void {
    this.modalConfig = new ModalConfig();
    this.modalConfig.showOrderPincode = true;
    this.setAdditionalModalConfig();
    this.registerComponent(PageNames.PINCODE_MODAL);
  }

  private registerComponent(pageName: PageNames) {
    this.navigationService.clearNavigation();
    this.navigationService.setCurrentPageComponent(pageName);
  }

  public onBack(): void {
    this.closeModal();
  }

  public backToDetailPage(): void {
    this.navigationService.resetNavigation();
    this.navigationService.clearNavigation();
    this.routeOnBackPressed();
  }

  private routeOnBackPressed() {
    this.router.navigate(['/product-details/' + this.completeRedirectUrl() ], {queryParamsHandling: 'merge'});
  }

  get orderSucceededTitleKey(): string {
    const pack = this.stateService.selectSnapshot(state => state.basket.selectedTvShopEntertainmentPack);
    return this.labelkeyService.getOrderSucceededTitleKey(pack);
  }

  get orderSucceededDescriptionKey(): string {
    const pack = this.stateService.selectSnapshot(state => state.basket.selectedTvShopEntertainmentPack);
    return this.labelkeyService.getOrderSucceededDescriptionKey(pack);
  }

  private setLabels() {
    const pack = this.stateService.selectSnapshot(state => state.basket.selectedTvShopEntertainmentPack);
    if (this.order && this.order.type === Order.DAYPASS) {
      this.title = 'eos-tv-shop-ii.title.input-pincode-modal-day-pass';
      this.description = 'eos-tv-shop-ii.text.input-pincode-modal-day-pass';
    }
    if (pack && (pack.isStreamingBundle || pack.isStreamingStandaloneProduct)) {
      this.title = 'eos-tv-shop-ii.title.input-pincode-modal-streaming-bundles';
      this.description = 'eos-tv-shop-ii.text.input-pincode-modal-streaming-bundles';
    }
  }

  private setAdditionalModalConfig() {
    const pack = this.stateService.selectSnapshot(state => state.basket.selectedTvShopEntertainmentPack);
    this.modalConfig.showLogo = !(pack && (pack.isStreamingBundle || pack.isStreamingStandaloneProduct));
    this.modalConfig.showHintInfoKey = !(pack && (pack.isStreamingBundle || pack.isStreamingStandaloneProduct));
  }

  private shouldComeBackToProductDetailScreen(): boolean {
    return this.navigationState.currentPageActiveComponent === PageNames.STREAMING_BUNDLE_OPTION ||
      this.navigationState.currentPageActiveComponent === PageNames.STANDALONE_FLAVORS ||
      this.navigationState.currentPageActiveComponent === PageNames.PACK_OPTION_SELECTION ;
  }

  private completeRedirectUrl(): boolean {
    let urlParameter;
    switch (this.navigationState.currentPageActiveComponent) {
      case PageNames.STREAMING_BUNDLE_OPTION:
      case PageNames.PACK_OPTION_SELECTION:
        urlParameter = this.order.packOmapiId;
        break;
      case PageNames.STANDALONE_FLAVORS:
        urlParameter = TvShopEntertainmentPackGroupIds.NETFLIX_STANDALONE;
        break;
    }
    return urlParameter;
  }
}
